module.exports = __webpack_public_path__ + "a5624a2c46ad67a80c0375aa78f2410e.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-medium.eot
// module id = 29
// module chunks = 0